import styled from 'styled-components'
import { HEADER_DEFAULT_Y } from '@/features/shared/constants/global'
import { NextLink } from '@/features/shared/elements/Link'
import { GridLayoutContainer } from '@/features/shared/styles/layout'
import { routes } from '@shared/constants/routes'
import { LogoIcon } from '@shipt/design-system-icons'
import { screenSizes } from '@shipt/design-system-themes'

export const GlobalHeaderLogoLink = ({
  className,
  holidayGHP,
}: {
  className?: string
  holidayGHP?: boolean
}) => (
  <NextLink href={routes.GLOBAL_HOMEPAGE.url} className={className}>
    <Logo aria-label="Shipt logo" $holidayGHP={holidayGHP} />
  </NextLink>
)

const Logo = styled(LogoIcon)<{ $holidayGHP?: boolean }>`
  color: ${({ theme, $holidayGHP }) =>
    $holidayGHP
      ? theme.color.content.base.neutral.primary_inverse
      : theme.color.content.base.neutral.primary};
  display: block;
`

export const GlobalHeaderContainer = styled(GridLayoutContainer)<{
  $holidayGHP?: boolean
}>`
  position: relative;
  height: ${HEADER_DEFAULT_Y}px;
  background-color: ${({ theme, $holidayGHP }) =>
    $holidayGHP
      ? theme.color.background.base.brand.primary
      : theme.color.background.base.neutral.subtle_00};
`

export const GlobalHeaderElement = styled.header`
  z-index: 999;
  top: 0;
  position: sticky;

  @media ${screenSizes.tablet} {
    .hideAboveTablet {
      display: none;
    }
  }

  @media ${screenSizes.max_mobile} {
    .hideOnMobile {
      display: none;
    }
  }
`
